import React, { useContext, useEffect, useState } from 'react'
import { DefectContext } from './SingleDefect'
import { DetailRow } from '../../../../components/Cards/DetailsBox'
import { Autocomplete, Link, Stack, TextField, Typography } from '@mui/material'
import API from '../../../../services/API'

const Asset = () => {
  const { defect, setDefect, setChangesPresent } = useContext(DefectContext)
  const [assetOptions, setAssetOptions] = useState([])

  useEffect(() => {
    API.get('/asset-list')
      .then((res) => {
        if (res.status === 200) {
          setAssetOptions(res.data)
        }
      })
      .catch((e) => console.error(e))
  }, [])

  return (
    <DetailRow label="Asset" noBorder>
      <Stack width="100%">
        <Autocomplete
          value={defect?.linkedAsset ?? defect.asset ?? null}
          fullWidth
          options={assetOptions}
          onChange={(e, value) => {
            console.log('value onChange', value)
            // console.log('VALUE', value)
            setDefect((prev) => ({
              ...prev,
              asset: value?._id ?? value,
              linkedAsset: value,
            }))
            console.log('defect', defect)
            setChangesPresent(true)
          }}
          renderInput={(params) => <TextField {...params} size="small" />}
          isOptionEqualToValue={(opt, value) => {
            return defect?.linkedAsset ? opt._id === value._id : true
          }}
          getOptionKey={(opt) => opt._id}
          getOptionLabel={(opt) => {
            return opt?.assetID ? `${opt.assetID} (${opt.category})` : opt
          }}
        />
        {defect?.linkedAsset ? (
          <Link
            href={`/asset-manager/${defect.linkedAsset.assetID}`}
            target="_blank"
          >
            View Asset
          </Link>
        ) : defect?.asset ? (
          <Typography variant="caption">Asset does not exist</Typography>
        ) : (
          ''
        )}
      </Stack>
    </DetailRow>
  )
}

export default Asset
